import React from "react";
import MenuContextProvider from "@/context/menu-context";
import SearchContextProvider from "@/context/search-context";
import Layout from "@/components/layout";
import Menu from "@/components/header-one";
import Footer from "@/components/footer";
import ContentEducacaoInfantil from "@/components/HeaderEducInfantil";
import SEO from '../components/seo'

const EducacaoInfantil = () => {
  return (
    <MenuContextProvider>
      <SearchContextProvider>
        <Layout>
          <SEO
            title="Educação Infantil - Foco em desenvolvimento integral e identidade árabe"
            pathname="/"
          />
          <Menu />
          <ContentEducacaoInfantil />
          <Footer /> 
        </Layout>
      </SearchContextProvider>
    </MenuContextProvider>
  )
}

export default EducacaoInfantil;
